import React from 'react';

import useWindowSize from '../../../../../../../hooks/use-window-size/src/use-window-size';

import * as S from './MyPartnerHeroBanner.styles';
// import bannerBg from '../../assets/banner-bg.png';
// import bannerMob from '../../assets/hero-banner-icon-mob.png';
// import hero2 from '../../assets/hero2.png';

const MyPartnerHeroBanner = ({heading, subHeading, cta, onStartBooking, bannerImage}) => {
  const winSize = useWindowSize();

  return (
    <S.PartnrHrBnr>
      {winSize.width > 768 ? (
        <img src={bannerImage} />
      ) : (
        <img src="https://assets-gos3.goibibo.com/myp_herodashboard_banner_pwa-1711542921.png" />
      )}
      {/* <S.PartnrHrBnrIcon>
        {
          winSize.width > 768 ?
            <img src={bannerBg} alt="icon" />
            : <img src={bannerMob} alt="icon" />
        }
      </S.PartnrHrBnrIcon>
      <S.PartnrHrBnrContent>
        {heading && <S.PartnrHrBnrHdng dangerouslySetInnerHTML={{ __html: heading }} />}
        {subHeading && <S.PartnrHrBnrSubHdng dangerouslySetInnerHTML={{ __html: subHeading }} />}
      </S.PartnrHrBnrContent> */}
      {/*cta && <S.PartnrHrBnrCta onClick={onStartBooking}>{cta}</S.PartnrHrBnrCta> */}
    </S.PartnrHrBnr>
  );
};

export default MyPartnerHeroBanner;
